var HashMap = require("../collections/hashMap.js");
var SortedMap = require("../collections/sortedMap.js");
var inherit = require("../general.js").inherit;
var sanityCheckHandler = require("./sanityCheckHandler.js");

var ObservableMap = function(validator){ // TODO: allow custom hash function?
    HashMap.call(this);

    if (typeof validator == "function") this.validator = validator;

    this.handlers = {
        put: null,
        putFail: null,
        remove: null
    };
};
inherit(ObservableMap, HashMap);

ObservableMap.prototype.getType = function(){return "map"}; // TODO: make type only a property type or constant TYPE, or define readonly property using Object.defineProperty ?

ObservableMap.prototype.put = function(key, val){
    var self = this;
    var oldVal = this.get(key);
    if (!(this.contains(key) && oldVal === val)) {
        var validated = !this.validator || this.validator(key, val, oldVal);
        if (validated) {
            HashMap.prototype.put.call(this, key, val);
            this.handlers.put && this.handlers.put.forEach(function (k, handler) {
                handler.call(self, key, val, oldVal);
            });
        } else {
            this.handlers.putFail && this.handlers.putFail.forEach(function (k, handler) {
                handler.call(self, key, val, oldVal);
            });
        }
        return validated;
    } else return true;
};

ObservableMap.prototype.remove = function(key) {
    var self = this;
    if (this.contains(key)) {
        var val = HashMap.prototype.remove.call(this, key);
        this.handlers.remove && this.handlers.remove.forEach(function(k, handler){
            handler.call(self, key, val);
        });
        return val;
    }
};

ObservableMap.prototype.onPut = function(key, handler, priority) {  // handlers without priority get default priority 0 and are sorted in insertion order
    sanityCheckHandler(arguments);
    if(!this.handlers.put) this.handlers.put = new SortedMap();
    this.handlers.put.put(key, handler, priority || 0);
};

ObservableMap.prototype.onPutFail = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.putFail) this.handlers.putFail = new SortedMap();
    this.handlers.putFail.put(key, handler, priority || 0);
};

ObservableMap.prototype.onRemove = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.remove) this.handlers.remove = new SortedMap();
    this.handlers.remove.put(key, handler, priority || 0);
};

ObservableMap.prototype.removeHandlers = function(key){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].remove(key);
            this._cleanHandlers(type);
        }
    }
};

ObservableMap.prototype.removeAllHandlers = function(col){
    for (var type in this.handlers) {
        if(this.handlers[type]) {
            this.handlers[type].removeAll(col);
            this._cleanHandlers(type);
        }
    }
};

ObservableMap.prototype.removeHandlersWhere = function(f){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].removeWhere(f);
            this._cleanHandlers(type);
        }
    }
};

ObservableMap.prototype._cleanHandlers = function(type) {
    if(this.handlers[type].size() == 0)
        this.handlers[type] = null;
};

module.exports = ObservableMap;